/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Audio_Recorder_Load_Devices_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to load audio devices: {error}" |
*
* @param {Audio_Recorder_Load_Devices_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_load_devices_failed = /** @type {((inputs: Audio_Recorder_Load_Devices_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Load_Devices_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec du chargement des périphériques audio : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Audiogeräte konnten nicht geladen werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile caricare i dispositivi audio: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось загрузить аудиоустройства: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al cargar los dispositivos de audio: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`音频设备加载失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`オーディオデバイスの読み込みに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ऑडियो डिवाइस लोड करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao carregar os dispositivos de áudio: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to load audio devices: ${i?.error}`)
});